const scrollTo = (id: string) => {
  const el = document.querySelector(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

const quickLinks = [
  { label: "Início", href: "#inicio" },
  { label: "Sobre o Escritório", href: "#sobre" },
  { label: "Áreas de Atuação", href: "#areas" },
  { label: "Revisão de Juros", href: "#revisao" },
  { label: "Contato", href: "#contato" },
];

export default function Footer() {
  return (
    <footer className="bg-[#2C2C2C] pt-16 pb-8">
      {/* Top border */}
      <div className="h-1 bg-[#B32025] -mt-16 mb-16" />

      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img
              src="https://storage.readdy-site.link/project_files/b0f92547-67a0-4c97-96b3-1197452eb2b3/fc98cc25-241d-4879-85d8-613dc6eb16cb_ivan-carlos-logo-transparente.png?v=c63336f769e63561aed8ffbf50c465c4"
              alt="Ivan Carlos Revisões de Juros"
              className="h-14 w-auto object-contain mb-5"
            />
            <p className="text-[#BFBFBF] text-sm leading-relaxed font-sans mb-6 max-w-sm">
              Especialistas em <strong className="text-white">revisão de juros abusivos</strong> e redução de dívida bancária. Advogados comprometidos com resultados reais para você.
            </p>
            <a
              href="https://wa.me/5554996914900?text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20quero%20falar%20com%20um%20advogado."
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#B32025] hover:bg-[#8E1A1E] text-white text-sm font-semibold px-5 py-3 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer font-sans"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-whatsapp-line text-base leading-none" />
              </div>
              +55 54 99691-4900
            </a>
          </div>

          {/* Quick links */}
          <div>
            <h4 id="footer-nav">
              <a className="text-white font-serif font-bold text-base mb-5 block">Links Rápidos</a>
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
                    className="text-[#BFBFBF] hover:text-[#B32025] text-sm font-sans transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 id="footer-contact">
              <a className="text-white font-serif font-bold text-base mb-5 block">Contato</a>
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-sm text-[#B32025] leading-none" />
                </div>
                <span className="text-[#BFBFBF] text-sm font-sans leading-relaxed">
                  Av. Pres. Vargas, 2545 – Sala 11<br />
                  São Cristóvão · Nova Prata – RS<br />
                  CEP: 95320-000
                </span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-whatsapp-line text-sm text-[#B32025] leading-none" />
                </div>
                <a
                  href="https://wa.me/5554996914900"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#BFBFBF] hover:text-white text-sm font-sans transition-colors cursor-pointer whitespace-nowrap"
                >
                  +55 54 99691-4900
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-instagram-line text-sm text-[#B32025] leading-none" />
                </div>
                <a
                  href="https://www.instagram.com/ivancarlosadvocados/"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="text-[#BFBFBF] hover:text-white text-sm font-sans transition-colors cursor-pointer whitespace-nowrap"
                >
                  @ivancarlosadvocados
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[#BFBFBF]/60 text-xs font-sans text-center md:text-left">
            © {new Date().getFullYear()} Ivan Carlos Revisões de Juros – Todos os direitos reservados · OAB/RS
          </p>
          <div className="flex items-center gap-6">
            <a
              href="https://startdigital1.com.br"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-[#BFBFBF]/40 hover:text-[#BFBFBF] text-xs font-sans transition-colors cursor-pointer whitespace-nowrap"
            >
              Desenvolvido por Start Digital
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
